import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'objectType'
})
export class ObjectTypePipe implements PipeTransform {

	transform(value: any, args?: any): string {

		if (value != undefined && value != null) {
			return value.constructor.name.toString();
		}
		return "";
	}

}



// WEBPACK FOOTER //
// ./src/app/brightserve/pipes/object-type.pipe.ts